import type { FaireProductEntity } from "../../entity_types/product";

export const p_5c4pm1hv: FaireProductEntity = {
  token: "p_5c4pm1hv",
  type: "product",
  name: "Hand-dipped 100% Beeswax Birthday Candles | Rainbow Ombré",
  brandToken: "b_a631ba79",
  brandName: "Knot & Bow",
  imageUrl:
    "https://cdn.faire.com/fastly/da2b455669ac17e358a6102293300fc5f9c5ea476d16431d243bf3b246e84490.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4dcb7d63d66c9a13421fc9f0d33441761dd31683fb976556b52a9b53de86675a.jpeg",
    "https://cdn.faire.com/fastly/9ad5688618c83cccec3a1f8655e08b73ee676e9139bffc0df3391934f3912c9b.jpeg",
    "https://cdn.faire.com/fastly/54c57fa950e8c5b38616585a78b20161fd281ae9b007d70da326f7b6e2625606.jpeg",
    "https://cdn.faire.com/fastly/a966009907afa64f795d5f7d1cd60c3586682c8ae5612fe13078a9e6366950a6.jpeg",
  ],
  priceDollars: 6,
  description:
    'These unique 100% pure beeswax birthday candles are hand-dipped and have a light natural beeswax scent. Traditional ivory fades into lovely ombré color. Details: 12 pure beeswax candles, 3" tall, Burn time of 10-15 minutes, Hand-dipped in Canada and assembled with love in Brooklyn.',
  tags: [],
  msrpDollars: 12,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:18.666Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
